import React from "react";
import { useLocation, Navigate } from "react-router-dom";

const RemoveTrailingSlash = ({ ...rest }): any => {
  const location = useLocation();

  // If the last character of the url is '/'
  if (location.pathname.match("/.*/$")) {
    return (
      <Navigate
        replace
        {...rest}
        to={{
          pathname: location.pathname.replace(/\/+$/, ""),
          search: location.search,
        }}
      />
    );
  } else return null;
};

export default RemoveTrailingSlash;
